import { Text } from '@kanda-libs/ks-design-library';

import Container from './Description-container';

import { SKELETONS } from '../../LineItem-constants';

const ViewComponent = () => (
  <Container>
    {({ description, isLoading, classNames }) => (
      <Text
        className={classNames.description}
        isLoading={isLoading}
        text={description}
        skeletonProps={SKELETONS.description}
      />
    )}
  </Container>
);

ViewComponent.displayName = 'LineItem-Description-view';

export default ViewComponent;
